import { render, staticRenderFns } from "./FrameworkPlacement.vue?vue&type=template&id=0ee5e998&scoped=true&"
import script from "./FrameworkPlacement.vue?vue&type=script&lang=js&"
export * from "./FrameworkPlacement.vue?vue&type=script&lang=js&"
import style0 from "./FrameworkPlacement.vue?vue&type=style&index=0&id=0ee5e998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee5e998",
  null
  
)

export default component.exports